/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { connect } from "react-redux";
import  KrpanoTour  from './KrpanoTour';
import PositionDateName from './../PositionDateName/PositionDateName';

class KrpanoTours extends React.Component {
  
  constructor(props){
    super(props);
  }

  render (){
    if(this.props.belowWindow === undefined && this.props.upperWindow === undefined){
      return null;
    }

    if(this.props.belowWindow == undefined){
      return (
        <>
          <div className="demo-page" style={{height: "100vh", position: "relative"}}>
            <PositionDateName tourName={this.props.upperWindow}/>
            <KrpanoTour name={this.props.upperWindow} id="upper" key={this.props.upperWindow} synchronized={this.props.syncViews}/>
          </div>
        </>
      )
    }
    else{
      return (
        <>
          <div className="demo-page" style={{height: this.props.upperWindowHeight+"vh", position: "relative"}}>
            <PositionDateName tourName={this.props.upperWindow}/>
            <KrpanoTour name={this.props.upperWindow} id="upper" key={this.props.upperWindow} synchronized={this.props.syncViews}/>
          </div>
          <div className="demo-page" style={{height: this.props.belowWindowHeight+"vh", position: "relative"}}>
            <PositionDateName tourName={this.props.belowWindow}/>
            <KrpanoTour name={this.props.belowWindow} id="below" key={this.props.belowWindow} synchronized={this.props.syncViews}/>
          </div>
        </>
      )
    }
  }

}
const mapStateToProps = state => ({
  upperWindow : state.upperWindow,
  belowWindow : state.belowWindow,
  upperWindowHeight : (100 - state.tourSliderValue),
  belowWindowHeight : state.tourSliderValue,
  syncViews : state.syncViews,
});

export default connect(mapStateToProps)(KrpanoTours)